import React, { useState, useEffect, useRef } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import { read, utils } from "xlsx";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import CommonAlert from "../common/Commonalert";
import Popup from "../common/popup";
import ChangePassword from "./changepassword";
import EditvendorDetails from "./editvendorDetails";
import CustomerImport from "../common/CustomerImport";
import { dateformatwithuktime } from "../utilityfunctions";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";
import moment from "moment";
import { canAction } from '../common/permissionhelper';
import { useTranslation } from "react-i18next";

const Vendors = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [transformedAccounts, setTransformedAccounts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [tempaccounts, setTempaccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popupView, setPopupView] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [Vendoremailadd, setVendoremailadd] = useState("");
  const [Vendoraccountcode, setVendoraccountcode] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [customeremail, setCustomeremail] = useState("");
  const [customeraccount, setCustomeraccount] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [editvendor, setEditvendor] = useState(false);
  const [VendorDetails, setVendorDetails] = useState(null);
  const [isActive, setIsActive] = useState([]);
  const [reason, setReason] = useState("");
  const [showReasonPopup, setShowReasonPopup] = useState(false);
  const [reasonError, setReasonError] = useState("");
  const [popuplogView, setPopuplogView] = useState("");
  const [popupPricebandView, setPopupPricebandView] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [showcustomPopup, setShowcustomPopup] = useState(false);
  const [popupImportView, setPopupImportView] = useState(false);
  const [importValue, setImportValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [statusFilterVal, setStatusFilterVal] = useState("");
  const [visibledeleteAlert, setVisibledeleteAlert] = useState(false);
  const [sortBy, setSortBy] = useState('all');
  const [range, setRange] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState(["pizza", "pasta", "desserts"]);
  const selectedCategoriesRef = useRef(["pizza", "pasta", "desserts"]);
  const [searchField, setSearchField] = useState("accountCode");
  const [searchFieldtxt, setSearchFieldtxt] = useState(t("account_code_txt"));
  const [suggestions, setSuggestions] = useState([]);
  const [subDepotList, setSubDepotList] = useState([]);
  const [mainDepotList, setMainDepotList] = useState([]);
  const [depots, setDepots] = useState([]);
  const [fullText, setFullText] = useState(false);
  const [restrictedAccounts, setRestrictedAccounts] = useState([]);
  const [isEmailToBeSent, setIsEmailToBeSent] = useState("");
  const [emailCount, setEmailCount] = useState("");
  const [showExportAlert, setShowExportAlert] = useState(false);
  const [showNoDataAlert, setShowNoDataAlert] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState({});
  const [originalAccounts, setOriginalAccounts] = useState([]);
  const [originalProducts, setOriginalProducts] = useState([]);
  const originalProductsRef = useRef([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [period, setPeriod] = useState("");
  const [periodtext, setPeriodtext] = useState("");
  const [dateinvalid_error, setDateinvalid_error] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [emailMode, setEmailMode] = useState("");
  const fileInputRef = useRef(null);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(sessionStorage.getItem("authData")).adminRole.permissions.includes("manage_customers")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    fetchRestrictedAccounts();
    getAccounts();
  }, []);

  const priceFormat = (price) => {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const handleImport = ($event) => {
    const files = $event.target.files;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        var loginDetails = {};
        if (window.sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
        }
        if (sheets.length) {
          let rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          let URL = BaseUrl + "admin/account/import";
          const payload = {
            data: rows,
            selectedFields: selectedFields,
          };
          http
            .post(URL, payload)
            .then((response) => {
              getAccounts();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const getAccounts = () => {
    setLoading(true);
    var loginDetails = {};
    if (window.sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + "admin/account";
    http
      .get(URL, {}, { timeout: 180000 })
      .then((response) => {
        const accountsData = response.data.data;
        const thresholdDate = new Date("2024-09-02");
        const transformedAccountsData = accountsData.map(account => {
          const createdAt = new Date(account.createdAt);
          const updatedAt = new Date(account.updatedAt);
          if (createdAt < thresholdDate) {
            account.createdAt = thresholdDate.toISOString();
          }
          if (updatedAt < thresholdDate) {
            account.updatedAt = thresholdDate.toISOString();
          }
          return account;
        });
        const uniqueSectors = [...new Set(
          transformedAccountsData
            .map((acc) => acc.Sectors)
            .filter((sector) => sector && sector.trim() !== "")
        )];
        setLoading(false);
        setOriginalAccounts(transformedAccountsData);
        setTempaccounts(transformedAccountsData);
        setAlertPopup(false);
        setAlertMessage("");
        setSectorOptions(uniqueSectors);
        if (statusFilterVal || searchTextVal) {
          applyFiltersWithOverrides({ tempaccounts: transformedAccountsData });
        } else {
          setAccounts(transformedAccountsData);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertPopup(true);
        setAlertMessage(t("server_busy_txt"));
      });
    let URL1 = BaseUrl + `admin/getdepots`;
    http
      .get(URL1)
      .then((response) => {
        let responseData = response.data.data;
        const uniqueDepots = Array.from(new Set(responseData.map(item => item.mainDepot)))
          .map(mainDepot => responseData.find(item => item.mainDepot === mainDepot));
        setSubDepotList(responseData);
        setDepots(responseData);
        setMainDepotList(uniqueDepots);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const editVendorDetails = (vendor) => {
    setEditvendor(true);
    setVendorDetails(vendor);
    setAlertMessage("");
  };

  const ediVendorsdetails = (formData) => {
    let URL = BaseUrl + "admin/editaccount/" + formData.cid;
    setLoading(true);
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    http
      .put(URL, formData)
      .then((response) => {
        let responseData = response.data.success;
        if (responseData) {
          setAlertPopup(true);
          setAlertMessage(t("account_details_updated_success_txt"));
        }
        setEditvendor(false);
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const sanitizeString = (input) => {
    let sanitized = input.trim().replace(/^,|,$/g, "");
    sanitized = sanitized.trim();
    return sanitized;
  };

  const viewVendorDetails = (vendor) => {
    setAlertPopup(false);
    setAlertMessage("");
    let addressFields = [
      sanitizeString(vendor.accountAddress1 || ""),
      sanitizeString(vendor.accountAddress2 || ""),
      sanitizeString(vendor.accountAddress3 || ""),
      sanitizeString(vendor.accountAddress4 || ""),
      sanitizeString(vendor.accountAddress5 || ""),
    ];
    var accountaddress = addressFields
      .filter((field) => field !== undefined && field != "")
      .join(", ");
    let popupResult = (
      <Popup
        extClass="order-pop info-poup"
        headMoreTxt={
          <>
            <div className="order-top">
              <div className="head">
                <h4>{t("customer_details_txt")}</h4>
              </div>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="order-top">
              <div className="bottom vendor-details vendor-table-view">
                <table className="vendor-table">
                  <tr>
                    <td>{t("account_code_txt")}</td>
                    <td>{vendor.accountCode}</td>
                  </tr>
                  <tr>
                    <td>{t("name_txt")}</td>
                    <td>{vendor.accountName}</td>
                  </tr>
                  <tr>
                    <td>{t("email_address_txt")}</td>
                    <td>{vendor.accountEmail}</td>
                  </tr>
                  {vendor.accountTelephone !== "0" && (
                    <tr>
                      <td>{t("telephone_number_txt")}</td>
                      <td>{vendor.accountTelephone}</td>
                    </tr>
                  )}
                  <tr>
                    <td>{t("address_txt")}</td>
                    <td>{accountaddress}</td>
                  </tr>
                  <tr>
                    <td>{t("accept_cwo_only_txt")}</td>
                    <td>{vendor.accountPaymentMethod}</td>
                  </tr>
                  <tr>
                    <td>{t("route_days_txt")}</td>
                    <td>{vendor.accountDeliverableDays}</td>
                  </tr>
                  <tr>
                    <td>{t("price_band_txt")}</td>
                    <td>{vendor.accountPriceListId}</td>
                  </tr>
                  <tr>
                    <td>{t("credit_limit")}</td>
                    <td>{vendor.CreditLimit}</td>
                  </tr>
                  <tr>
                    <td>{t("account_objective1_txt")}</td>
                    <td>{vendor.AccountObjective1}</td>
                  </tr>
                  <tr>
                    <td>{t("account_objective2_txt")}</td>
                    <td>{vendor.AccountObjective2}</td>
                  </tr>
                  <tr>
                    <td>{t("website_access")}</td>
                    <td>{vendor.accountWebSiteAccess}</td>
                  </tr>
                  {vendor.Sectors && (
                    <tr>
                      <td>{t("cus_sector_txt")}</td>
                      <td>{vendor.Sectors}</td>
                    </tr>
                  )}
                  <tr>
                    <td>{t("main_depot_txt")}</td>
                    <td>{vendor.mainDepot}</td>
                  </tr>
                  <tr>
                    <td>{t("local_depot_txt")}</td>
                    <td>{vendor.subDepot}</td>
                  </tr>
                  <tr>
                    <td>{t("created_date_txt")}</td>
                    <td>{dateformatwithuktime(vendor.createdAt)}</td>
                  </tr>
                  <tr>
                    <td>{t("updated_date_txt")}</td>
                    <td>{dateformatwithuktime(vendor.updatedAt)}</td>
                  </tr>
                  {vendor.lastLogin && (<tr>
                    <td>{t("last_login_text")}</td>
                    <td>{dateformatwithuktime(vendor.lastLogin)}</td>
                  </tr>)}
                </table>
              </div>
            </div>
          </>
        }
        closebtn={
          <>
            <span
              onClick={() => setPopupView("")}
              className="close"
            ></span>
          </>
        }
      />
    );
    setPopupView(popupResult);
  };

  const showConfirmationDialog = () => {
    if (confirmationAction.action === "activate" && !isEmailToBeSent) {
      setEmailError(true);
      return;
    }
    if (reason !== "") {
      setAlertPopup(false);
      setShowReasonPopup(false);
      setShowDialog(true);
    } else {
      setReasonError(true);
    }
  };

  const showReasonDialog = (accountcode, action) => {
    setShowReasonPopup(true);
    setReasonError(false);
    setIsEmailToBeSent("");
    setEmailCount(null);
    setConfirmationAction({ accountcode, action });
  };

  const hideConfirmationDialog = () => {
    setAlertPopup(false);
    setShowDialog(false);
    setShowReasonPopup(false);
    setReason("");
    setReasonError(false);
  };

  const confirmActionHandler = () => {
    const { accountcode, action } = confirmationAction;
    confirmAction(accountcode, action);
    hideConfirmationDialog();
  };

  const toggleCustomerStatus = (accountcode) => {
    const account = accounts.find((p) => p.accountCode === accountcode);
    const isCurrentlyActive = account.accountStatus;
    const action = isCurrentlyActive === "active" ? "deactivate" : "activate";
    showReasonDialog(accountcode, action);
  };

  const confirmAction = (accountcode, action) => {
    let URL = BaseUrl + "admin/accountstatus";
    const payload = {
      accountCode: accountcode,
      accountStatus: action === "activate" ? "active" : "deactive",
    };
    if (action === "activate") {
      payload.isEmailToBeSent = isEmailToBeSent;
      if (isEmailToBeSent === "yes") {
        payload.emailMode = emailMode || "fresh";
      }
    }
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    http
      .put(URL, payload)
      .then(async (response) => {
        if (response.status === 200) {
          setAccounts(prevAccounts =>
            prevAccounts.map((account) =>
              account.accountCode === accountcode
                ? { ...account, accountStatus: payload.accountStatus }
                : account
            )
          );
          setTempaccounts(prevTempaccounts =>
            prevTempaccounts.map((account) =>
              account.accountCode === accountcode
                ? { ...account, accountStatus: payload.accountStatus }
                : account
            )
          );
          let noteURL = BaseUrl + "admin/accountlog";
          let noteText = '';
          if (isEmailToBeSent === "yes" && action === "activate") {
            noteText = action + " - " + reason + " - " + t("intro_email_sent_txt");
          } else {
            noteText = action + " - " + reason;
          }
          const notepayload = {
            accountCode: accountcode,
            noteText: noteText,
            createdBy: loginDetails.adminName,
          };
          http.post(noteURL, notepayload).then(async (response) => {
            const actionMsg =
              action.trim() === "activate"
                ? isEmailToBeSent === "yes"
                  ? t("customer_activated_with_email_txt", { accountCode: accountcode })
                  : t("customer_activated_txt", { accountCode: accountcode })
                : t("customer_deactivated_txt", { accountCode: accountcode });
            console.log(actionMsg);
            setShowcustomPopup(true);
            setUploadMessage(actionMsg);
          });
          hideConfirmationDialog();
        }
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
        alert(t("update_customer_failed_txt"));
      });
  };

  const changePassword = (customer) => {
    setShowPopup(true);
    setVendoremailadd(customer.accountEmail);
    setVendoraccountcode(customer.accountCode);
  };

  const triggerEmail = (customer) => {
    setShowPopup(false);
    setAlertMessage('');
    setVisibleAlert(true);
    setCustomeremail(customer.accountEmail);
    setCustomeraccount(customer.accountCode);
  };

  const CustomerStatuslog = (accountCode) => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + "admin/accountlog/" + accountCode;
    http
      .get(URL)
      .then(async (response) => {
        let responseData = [];
        responseData = response.data.data;
        viewlogDetails(responseData, accountCode);
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
      });
  };

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const viewlogDetails = (acc_det, accountCode) => {
    let popupResult = (
      <Popup
        extClass="info-poup show"
        closebtn={
          <>
            <span
              onClick={() => setPopuplogView("")}
              className="close"
            ></span>
          </>
        }
        headMoreTxt={
          <>
            <div className="order-top">
              <h4>
                <span>{t("customer_status_log_details_txt")} - {accountCode}</span>
              </h4>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="bottom vendor-details acc-log">
              {acc_det && acc_det.length > 0 ? (
                acc_det.map((acc_item) => {
                  const [accstatus, notes, introEmailSent = ''] = acc_item.noteText.split(" - ");
                  let accactionstatus =
                    accstatus.trim() === "activate"
                      ? introEmailSent
                        ? `${t("activated_txt")} - ${introEmailSent}`
                        : t("activated_txt")
                      : t("deactivated_txt");
                  let createdby = acc_item.createdBy ? (
                    <>
                      <span className="log-user">{acc_item.createdBy}</span>
                      <span className="log-line">|</span>
                    </>
                  ) : (
                    ""
                  );
                  return (
                    <div className="info-item">
                      <div className="info-innr">
                        <div className="flex-log-hdr">
                          <p>
                            <span className="labeltxt acn-by">
                              {accactionstatus}
                            </span>
                          </p>
                          <div className="hdrlog-rit">
                            {createdby}
                            <span className="log-date">
                              {dateformatwithuktime(acc_item.createdAt)}
                            </span>
                          </div>
                        </div>
                        <p>
                          <span className="labeltxt log-reason">{t("reason_txt")}: </span>
                          {notes ? notes.trim() : ""}
                        </p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-logs">{t("no_logs_txt")}</div>
              )}
            </div>
          </>
        }
      />
    );
    setPopuplogView(popupResult);
  };

  const triggerMail = () => {
    let URL = BaseUrl + "forgotpassword";
    let payload = {
      emailaddress: customeremail,
      accountCode: customeraccount,
      type: "admin",
    };
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    setVisibleAlert(false);
    setLoading(true);

    http
      .post(URL, payload)
      .then((response) => {
        setAlertPopup(true);
        setAlertMessage(t("reset_password_link_sent_txt"));
        setLoading(false);
        setCustomeremail("");
        setShowPopup(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setCustomeremail("");
    setCustomeraccount("");
    setAlertPopup(false);
  };

  const DeletePopupclose = () => {
    setVisibledeleteAlert(false);
    setCustomeraccount("");
    setAlertPopup(false);
  };

  const closepopup = (alrtpopup, alrtmsg) => {
    setShowPopup(false);
    setAlertPopup(alrtpopup);
    setAlertMessage(alrtmsg);
  };

  const editclosepopup = (alrtpopup, alrtmsg) => {
    setEditvendor(false);
    setAlertPopup(alrtpopup);
    setAlertMessage(alrtmsg);
    setShowPopup(false);
  };

  const viewProducts = (vendor) => {
    setAlertPopup(false);
    setAlertMessage("");
    let URL = BaseUrl + `admin/productsbasedonband/${vendor.accountPriceListId}`;
    http
      .get(URL)
      .then((response) => {
        let responseProducts = response.data.data;
        originalProductsRef.current = responseProducts;
        setOriginalProducts(responseProducts);
        viewProductsPopup(responseProducts, vendor.accountPriceListId);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getFilteredProducts = (responseProducts, currentSelectedCategories) => {
    const categoryMap = {
      pizza: ['1'],
      pasta: ['10', '13', '11', '12'],
      desserts: ['14']
    };
    const selectedCategoryIds = currentSelectedCategories
      .flatMap((category) => categoryMap[category] || []);
    responseProducts.sort((a, b) => parseFloat(a.PDP_Price1) - parseFloat(b.PDP_Price1));
    return responseProducts.filter((prd) => selectedCategoryIds.includes(prd.categoryId));
  };

  const viewProductsPopup = (responseProducts, priceband, currentSelectedCategories) => {
    const cats = currentSelectedCategories || selectedCategories;
    const filteredProducts = getFilteredProducts(responseProducts, cats);
    let popupResult = (<Popup
      extClass="order-pop info-poup"
      headMoreTxt={
        <>
          <div className="order-top">
            <div className="head">
              <h4>{t("product_details_txt")} - {responseProducts[0].PDP_Reference}</h4>
            </div>
          </div>
        </>
      }
      bodyMoreTxt={
        <>
          <div className="order-top">
            <div className="bottom product-details vendor-table-view">
              <div className="custom_check-box">
                <div className='edit-free-cat-chks'>
                  <div className="check-box inline">
                    <input
                      type="checkbox"
                      id="cat01"
                      name="pizza"
                      onChange={handleCategoryChange}
                      checked={cats.includes("pizza")}
                    />
                    <label for="cat01">{t("pizza_txt")}<span class="ctgry-icon pizza"></span></label>
                  </div>
                  <div class="check-box inline">
                    <input
                      type="checkbox"
                      id="cat02"
                      name="pasta"
                      onChange={handleCategoryChange}
                      checked={cats.includes("pasta")}
                    />
                    <label for="cat02">{t("pasta_txt")}<span class="ctgry-icon pasta"></span></label>
                  </div>
                  <div class="check-box inline">
                    <input
                      type="checkbox"
                      id="cat04"
                      name="desserts"
                      onChange={handleCategoryChange}
                      checked={cats.includes("desserts")}
                    />
                    <label for="cat04">{t("desserts_txt")}<span class="ctgry-icon desserts"></span></label>
                  </div>
                </div>
              </div>
              <table className="vendor-table">
                <tr>
                  <th>{t("product_txt")}</th>
                  <th>{t("unit_of_sale_txt")}</th>
                  <th>{t("price_txt")}</th>
                </tr>
                {filteredProducts?.length > 0 ? (
                  filteredProducts.map((product) => (<tr>
                    <td>{`${product.productDescription} (${product.productNumber.includes("_")
                      ? product.productNumber.substring(0, product.productNumber.indexOf("_"))
                      : product.productNumber
                      })`}   <a
                        className="title-tooltip title-right"
                        data-title={product.categoryId === "1"
                          ? t("categories.pizza")
                          : ["10", "13", "11", "12"].includes(product.categoryId)
                            ? t("categories.pasta_rice_noodle_sauces")
                            : product.categoryId === "14"
                              ? t("categories.desserts")
                              : ""}
                      >
                      </a></td>
                    <td>{product.packageSize}</td>
                    <td>{priceFormat(Number(product.PDP_Price1))}</td>
                  </tr>))) : (<tr>
                    <td colSpan="3">{t("no_products_found_txt")}</td>
                  </tr>)}
              </table>
            </div>
          </div>
        </>
      }
      closebtn={
        <>
          <span
            onClick={() => {
              setPopupPricebandView("");
              selectedCategoriesRef.current = ['pizza', 'pasta', 'desserts'];
              setSelectedCategories(['pizza', 'pasta', 'desserts']);
            }}
            className="close"
          ></span>
        </>
      }
    />);
    setPopupPricebandView(popupResult);
  };

  const handleCategoryChange = (event) => {
    const category = event.target.name;
    const currentCategories = selectedCategoriesRef.current;
    let updatedCategories;
    if (currentCategories.includes(category)) {
      updatedCategories = currentCategories.filter((item) => item !== category);
    } else {
      updatedCategories = [...currentCategories, category];
    }
    selectedCategoriesRef.current = updatedCategories;
    setSelectedCategories(updatedCategories);
    viewProductsPopup(originalProductsRef.current, undefined, updatedCategories);
  };

  const handleReset = () => {
    setSearchTextVal("");
    setSearchField("accountCode");
    setSearchFieldtxt(t("account_code_txt"));
    setAccounts(tempaccounts);
    setShowPopup(false);
    setAlertPopup(false);
    setSuggestions([]);
    // applyFilters will be called via the state reset – call directly here
    applyFiltersWithOverrides({ searchTextVal: "", searchField: "accountCode", statusFilterVal });
  };

  const handleFieldChange = (e) => {
    setSearchField(e.target.value);
    setSearchFieldtxt(e.target.options[e.target.selectedIndex].text);
    setSearchTextVal("");
    setSuggestions([]);
  };

  const handleSuggestionClick = (selectedValue) => {
    setSearchTextVal(selectedValue);
    setSuggestions([]);
    applyFiltersWithOverrides({ searchTextVal: selectedValue, exactMatch: true });
  };

  const handleChange = (value) => {
    console.log(value);
    setSearchTextVal(value);
    setAlertPopup(false);
    setShowPopup(false);
    applyFiltersWithOverrides({ searchTextVal: value });
    if (searchField === "accountPriceListId") {
      if (value.trim() === "") {
        setSuggestions([]);
        return;
      }
      const newSuggestions = [...new Set(tempaccounts
        .map((acc) => acc.accountPriceListId)
        .filter((item) => item && item.toLowerCase().includes(value.toLowerCase()))
      )];
      setSuggestions(newSuggestions);
    }
  };

  const handleReasonChange = async (value) => {
    setReason(value);
    setReasonError(false);
  };

  const handleStatusChange = (value) => {
    setStatusFilterVal(value);
    applyFiltersWithOverrides({ statusFilterVal: value });
  };

  const triggerSessionDelete = (customer) => {
    setVisibledeleteAlert(true);
    setCustomeraccount(customer);
  };

  const triggerDelete = () => {
    let URL = BaseUrl + `admin/deletesession/${customeraccount}`;
    setVisibledeleteAlert(false);
    setLoading(true);
    http
      .delete(URL)
      .then((response) => {
        setAlertPopup(true);
        setAlertMessage(
          t("session_deleted_success_txt", {
            accountCode: customeraccount,
          })
        );
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSearchClick = () => {
    setSuggestions([]);
    applyFiltersWithOverrides({ exactMatch: false });
  };

  const fetchRestrictedAccounts = () => {
    http.get(BaseUrl + 'admin/accountcodelist')
      .then((res) => {
        const ids = res.data?.data?.map(acc => acc.accountCode);
        setRestrictedAccounts(ids || []);
      })
      .catch((err) => {
        console.error("Failed to load restricted accounts", err);
      });
  };
  // Helper to apply filters with overrides (since setState is async in class, we pass overrides here)
  const applyFiltersWithOverrides = (overrides = {}) => {
    const effectiveSearchTextVal = overrides.searchTextVal !== undefined ? overrides.searchTextVal : searchTextVal;
    const effectiveSearchField = overrides.searchField !== undefined ? overrides.searchField : searchField;
    const effectiveStatusFilterVal = overrides.statusFilterVal !== undefined ? overrides.statusFilterVal : statusFilterVal;
    const exactMatch = overrides.exactMatch !== undefined ? overrides.exactMatch : false;
    const effectiveTempaccounts = overrides.tempaccounts !== undefined ? overrides.tempaccounts : tempaccounts;
    const effectiveRestrictedAccounts = overrides.restrictedAccounts !== undefined ? overrides.restrictedAccounts : restrictedAccounts;
    let lowercasedText = effectiveSearchTextVal.toLowerCase().trim();
    let lowercasedStatus = effectiveStatusFilterVal.toLowerCase().trim();
    let filteredData = effectiveTempaccounts;
    if (lowercasedStatus) {
      filteredData = filteredData.filter((item) =>
        item.accountStatus && item.accountStatus.toLowerCase() === lowercasedStatus
      );
      filteredData = filteredData.filter(account => !effectiveRestrictedAccounts.includes(account.accountCode));
    }
    if (lowercasedText) {
      filteredData = filteredData.filter((item) => {
        const accountCode = item.accountCode;
        const isExcluded = effectiveRestrictedAccounts.includes(accountCode);
        if (effectiveSearchField === "accountName") {
          return item.accountName.toLowerCase().includes(lowercasedText);
        } else if (effectiveSearchField === "accountCode") {
          return item.accountCode.toLowerCase().includes(lowercasedText);
        } else if (effectiveSearchField === "accountEmail") {
          return item.accountEmail.toLowerCase().includes(lowercasedText);
        } else if (effectiveSearchField === "accountPriceListId") {
          if (isExcluded) return false;
          return exactMatch
            ? item.accountPriceListId.toLowerCase() === lowercasedText
            : item.accountPriceListId.toLowerCase().includes(lowercasedText);
        } else if (effectiveSearchField === "Sectors") {
          if (isExcluded) return false;
          return item.Sectors?.toLowerCase() === lowercasedText;
        } else if (effectiveSearchField === "mainDepot") {
          if (isExcluded) return false;
          return item.mainDepot?.toLowerCase() === lowercasedText;
        } else if (effectiveSearchField === "subDepot") {
          if (isExcluded) return false;
          return item.subDepot?.toLowerCase() === lowercasedText;
        }
        return false;
      });
    }
    setAccounts(filteredData);
    setSearchResults(filteredData);
  };

  const applyFilters = (exactMatch = false) => {
    applyFiltersWithOverrides({ exactMatch });
  };

  const filterData = (value, filterType = "search") => {
    const lowercasedValue = value.toLowerCase().trim();
    let baseData = filterType === "status" && searchTextVal ? searchResults : tempaccounts;
    let filteredData = [];
    if (filterType === "status") {
      if (lowercasedValue === "active" || lowercasedValue === "deactive") {
        filteredData = baseData.filter((item) =>
          item.accountStatus && item.accountStatus.toString().toLowerCase() === lowercasedValue
        );
        filteredData = filteredData.filter(account => !restrictedAccounts.includes(account.accountCode));
      } else {
        filteredData = baseData;
      }
    } else {
      filteredData = tempaccounts.filter((item) => {
        return (
          item.accountName.toLowerCase().includes(lowercasedValue) ||
          item.accountCode.toLowerCase().includes(lowercasedValue) ||
          item.accountEmail.toLowerCase().includes(lowercasedValue) ||
          item.accountPriceListId.toLowerCase().includes(lowercasedValue) ||
          item.Sectors?.toLowerCase().includes(lowercasedValue) ||
          item.mainDepot?.toLowerCase().includes(lowercasedValue) ||
          item.subDepot?.toLowerCase().includes(lowercasedValue)
        );
      });
      setSearchResults(filteredData);
    }
    setAccounts(filteredData);
  };

  const handlesortbyChange = (value) => {
    setSortBy(value);
    setPeriod("");
    setPeriodtext("");
    setShowDatePicker(false);
    setRange('');
    setFromDate('');
    setToDate('');
    setAlertPopup(false);
    setAlertMessage("");
    if (value === "all") {
      getAccounts();
    }
  };

  const handlesortChange = (value, text) => {
    setPeriod(value);
    setPeriodtext(text);
    setShowDatePicker(false);
    if (value === 'custom') {
      setShowDatePicker(true);
      setRange(value);
    } else {
      setRange(value);
      setShowDatePicker(false);
      setFromDate('');
      setToDate('');
      const payload = {
        filterby: sortBy,
        period: value,
        datefrom: "",
        dateto: ""
      };
      callApi(payload);
    }
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // callApiIfDatesSelected will need toDate too, handle inline
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const DateChange = (value, type) => {
    if (type === "from") {
      if (toDate && value > toDate) {
        setFromDate(value);
        setToDate("");
        setDateinvalid_error(true);
      } else {
        setFromDate(value);
        setDateinvalid_error(false);
      }
    } else if (type === "to") {
      if (fromDate && fromDate > value) {
        setToDate("");
        setDateinvalid_error(true);
      } else {
        setToDate(value);
        setDateinvalid_error(false);
      }
    }
  };
  // Watch fromDate/toDate changes to call API when both selected
  useEffect(() => {
    if (fromDate && toDate) {
      setShowDatePicker(false);
      const payload = {
        filterby: sortBy,
        period: "custom",
        datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
        dateto: format(new Date(toDate), "yyyy-MM-dd")
      };
      callApi(payload);
    }
  }, [fromDate, toDate]);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setUploadMessage("");
      setShowPopup(false);
    }
  };

  const handleUpload = (file, selectedFields) => {
    if (file) {
      const reader = new FileReader();
      setIsUploading(true);
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        var loginDetails = {};
        if (window.sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
        }
        if (sheets.length) {
          let rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          let URL = BaseUrl + "admin/account/import";
          const payload = {
            data: rows,
            selectedFields: selectedFields,
          };
          http
            .post(URL, payload)
            .then((response) => {
              getAccounts();
              setIsUploading(false);
              setUploadMessage(t("customers_imported_successfully_txt"));
              setShowcustomPopup(true);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const closeCustomPopup = () => {
    setShowcustomPopup(false);
    setUploadMessage("");
  };

  const importButtonClick = (value) => {
    setPopupImportView(true);
    setImportValue(value);
  };

  const importClosepopup = (event, shouldUpload, file, importValue, selectedFields) => {
    if (shouldUpload && file) {
      uploadFile(file, importValue, selectedFields);
    }
    setPopupImportView(false);
    setImportValue("");
    setSelectedFile(null);
  };

  const uploadFile = (file, importValue, selectedFields) => {
    if (importValue === "Customer") {
      handleUpload(file, selectedFields);
    }
  };

  const handleConfirmExportToExcel = () => {
    const records = accounts;
    if (!records || records.length === 0) {
      setShowNoDataAlert(true);
      return;
    }
    setShowExportAlert(true);
  };

  const handleCloseExportAlert = () => {
    setShowExportAlert(false);
  };

  const handleCloseNoDataAlert = () => {
    setShowNoDataAlert(false);
  };

  const handleExportToExcel = () => {
    const records = accounts;
    if (!records || records.length === 0) return;
    const rawStatus = statusFilterVal;
    const trimmed = typeof rawStatus === "string" ? rawStatus.trim() : "";
    let statusText = "All";
    if (trimmed && trimmed !== "") {
      const statusMapping = {
        "active": t("active_txt"),
        "deactive": t("inactive_txt"),
      };
      statusText = statusMapping[trimmed] || (trimmed.charAt(0).toUpperCase() + trimmed.slice(1));
    }
    const searchFieldMapping = {
      accountCode: t("account_code_txt"),
      accountName: t("account_name_txt"),
      accountEmail: t("email_address_txt"),
      accountPriceListId: t("price_band_txt"),
      Sectors: t("cus_sector_txt"),
      mainDepot: t("main_depot_txt"),
      subDepot: t("local_depot_txt")
    };
    const sortByMapping = {
      Ordered: t("ordered_txt"),
      "Not Ordered": t("not_ordered_txt"),
      lastLogin: t("last_login_text"),
      createdAt: t("created_on_txt"),
      updatedAt: t("updated_on_txt"),
      "Intro Email Sent": t("intro_email_sent_txt"),
    };
    const firstFilterType = searchField ? searchFieldMapping[searchField] : null;
    const firstFilterValue = searchTextVal ? searchTextVal : null;
    const sortByText = sortBy && sortBy !== "all" ? sortByMapping[sortBy] : null;
    let dateRangeText = "";
    if (sortBy && sortBy !== "all") {
      if (period === "custom" && fromDate && toDate) {
        dateRangeText = `(${formatDate(fromDate)} - ${formatDate(toDate)})`;
      } else if (periodtext) {
        dateRangeText = `(${periodtext})`;
      }
    } else {
      dateRangeText = `(${t("past_30_days_txt")})`;
    }
    let firstRowText = t("tugo_txt");
    if (statusText) firstRowText += ` ${statusText}`;
    firstRowText += ` ${t("customers_txt")}`;
    if (sortByText) firstRowText += ` - ${sortByText}`;
    const parts = [];
    if (firstFilterType && firstFilterValue)
      parts.push(
        t("groupedBy", {
          filterType: firstFilterType,
          filterValue: firstFilterValue,
        })
      );
    parts.push(
      t("totalRecords", {
        count: records.length,
        dateRange: dateRangeText,
      })
    );
    if (parts.length > 0) {
      firstRowText += ` | ${parts.join(" | ")}`;
    }
    let headers = [t("account_code_txt"), t("account_name_txt"), t("email_address_txt"), t("price_band_txt"), t("cus_sector_txt"), t("local_depot_txt")];
    if (statusText === "All") {
      headers.push("Status");
    }
    const headerStyle = { font: { bold: true }, alignment: { horizontal: "left" } };
    const styledHeaders = headers.map(h => ({ v: h, s: headerStyle }));
    const rows = records.map(item => {
      console.log(item);
      const rowData = [
        item.accountCode,
        item.accountName,
        item.accountEmail,
        item.accountPriceListId,
        item.Sectors || t("na_txt"),
        item.subDepot || t("na_txt")
      ];
      if (statusText === t("all_txt")) {
        const rawStatus = (item.accountStatus || "").toString().trim().toLowerCase();
        let readableStatus = t("unknown_txt");
        if (rawStatus === "active") readableStatus = t("active_txt");
        else if (rawStatus === "deactive") readableStatus = t("inactive_txt");
        rowData.push(readableStatus);
      }
      return rowData;
    });
    const worksheetData = [
      [{ v: firstRowText, s: { font: { bold: true }, alignment: { horizontal: "left" } } }],
      styledHeaders,
      ...rows
    ];
    const columnWidths = headers.map((header, index) => {
      let maxLength = header.length;
      rows.forEach(row => { maxLength = Math.max(maxLength, String(row[index]).length); });
      return { wch: maxLength + 5 };
    });
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendors");
    const exportDateTime = moment().format("DD-MM-YYYY");
    const fileName = `${t("customers_report_txt")}-${exportDateTime}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(blob, fileName);
    setShowExportAlert(false);
  };

  const callApi = (payload) => {
    if (payload.filterby === "createdAt" || payload.filterby === "updatedAt") {
      filterFromOriginalState(payload);
      return;
    }
    const URL = `${BaseUrl}admin/account`;
    setLoading(true);
    http.post(URL, payload)
      .then((response) => {
        let responseData = response.data.data;
        if (payload.filterby === "Not Ordered" || payload.filterby === "lastLogin") {
          responseData = responseData.filter(
            (item) => !restrictedAccounts.includes(item.accountCode)
          );
        }
        setAccounts(responseData);
        setLoading(false);
        setTempaccounts(responseData);
        setAlertPopup(false);
        setAlertMessage("");
        if (statusFilterVal || searchTextVal) {
          applyFiltersWithOverrides({ tempaccounts: responseData });
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertPopup(true);
        setAlertMessage(t("server_busy_txt"));
        setLoading(false);
      });
  };

  const filterFromOriginalState = (payload) => {
    let from, to;
    if (payload.period === "custom") {
      from = new Date(`${payload.datefrom}T00:00:00`);
      to = new Date(`${payload.dateto}T23:59:59`);
    } else {
      const days = parseInt(payload.period, 10);
      to = new Date();
      from = new Date();
      from.setDate(from.getDate() - days);
    }
    let filtered = originalAccounts.filter(account => {
      const dateToCompare = payload.filterby === "createdAt"
        ? new Date(account.createdAt)
        : new Date(account.updatedAt);
      return dateToCompare >= from && dateToCompare <= to;
    });
    filtered = filtered.filter(account => !restrictedAccounts.includes(account.accountCode));
    setAccounts(filtered);
    setTempaccounts(filtered);
    setLoading(false);
    setAlertPopup(false);
    setAlertMessage("");
    if (statusFilterVal || searchTextVal) {
      applyFiltersWithOverrides({ tempaccounts: filtered });
    }
  };

  var loginemail = "";
  if (sessionStorage.getItem("authData")) {
    loginemail = JSON.parse(sessionStorage.getItem("authData")).adminEmail;
  }

  const columns = [
    {
      name: t("account_name_txt"),
      selector: (row) => row.accountName,
      sortable: true,
    },
    {
      name: t("account_code_txt"),
      selector: (row) => row.accountCode,
      sortable: true,
    },
    {
      name: t("email_address_txt"),
      selector: (row) => row.accountEmail,
      sortable: false,
    },
    {
      name: t("price_band_txt"),
      selector: (row) => row.accountPriceListId,
      sortable: true,
    },
    {
      name: t("sector_txt"),
      selector: (row) => row.Sectors ? (!fullText ? <a
        className="title-tooltip title-up"
        data-title={row.Sectors}
      >
        <i className="fa fa-industry" aria-hidden="true"></i>
      </a> : row.Sectors) : t("na_txt"),
      sortable: true,
    },
    {
      name: t("local_depot_txt"),
      selector: (row) => row.subDepot ? (!fullText ? <a
        className="title-tooltip title-up"
        data-title={row.subDepot}
      >
        <i className="fa fa-map-marker" aria-hidden="true"></i>
      </a> : row.subDepot) : t("na_txt"),
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row, index) => (
        <div>
          {canAction('manage_customers', 'view') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("view_details_txt")}
              style={{ color: "white" }}
              onClick={() => viewVendorDetails(row)}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </a>
          )}
            {canAction('manage_customers', 'edit') && (loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("edit_details_txt")}
              style={{ color: "white" }}
              onClick={() => editVendorDetails(row)}
            >
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </a>
          )}
          {canAction('manage_customers', 'resetpassword') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("change_password_txt")}
              style={{ color: "white" }}
              onClick={() => changePassword(row)}
            >
              <i className="fa fa-key"></i>
            </a>
          )}
          {canAction('manage_customers', 'view') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("view_products_txt")}
              style={{ color: "white" }}
              onClick={() => viewProducts(row)}
            >
              <i className="fa fa-gbp" aria-hidden="true"></i>
            </a>)}
            {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && (<>
                {canAction('manage_customers', 'resetpassword') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("reset_password_email_trigger_txt")}
              style={{ color: "white" }}
              onClick={() => triggerEmail(row)}
            >
              <i className="fa fa-envelope-o"></i>
            </a>)}
            </>
            )}
            {canAction('manage_customers', 'activate') && (
            <a
              className={`button title-tooltip title-up ${row.accountStatus === "active" ? "activate" : "deactivate"}`}
              data-title={t("customer_activate_deactivate_txt")}
              onClick={() => toggleCustomerStatus(row.accountCode)}
            >
              <i
                className={`fa ${row.accountStatus === "active" ? "fa-unlock" : "fa-lock"}`}
              ></i>
            </a>
          )}
          {canAction('manage_customers', 'activate') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("customer_status_log_txt")}
              onClick={() => CustomerStatuslog(row.accountCode)}
            >
              <i className="fa fa-file-text-o"></i>
            </a>)}
            {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && canAction('manage_customers', 'delete') && (<a
              className="button title-tooltip title-up"
              data-title={t("delete_session_text")}
              onClick={() => triggerSessionDelete(row.accountCode)}
            >
              <i className="fa fa-history"></i>
            </a>
          )}
        </div>
      ),
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      {alertPopup == true && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <div className="flex-title">
                <h1 className="checkout-title">{t("customers_txt")}</h1>
                <div className="prod-import-btn odr-expo-btn">
                  {canAction('manage_customers', 'export') && (
                    <a
                      data-title={t("export_filtered_records_txt")}
                      className="export-btn button title-tooltip title-left"
                      onClick={handleConfirmExportToExcel}
                    >
                      {t("export_btn_txt")}
                    </a>
                  )}{" "}
                  {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && 
                    canAction('manage_customers', 'import') && (
                    <a
                      data-title={t("import_customer_records_txt")}
                      className="import-btn button title-tooltip title-left"
                      onClick={() => importButtonClick("Customer")}
                    >
                      {t("import_txt")}
                    </a>
                  )}
                </div>
              </div>
              <div className="right-table-outer-wrap vendors-table-wrap">
                <div className="table-filter search-orders">
                  <div className="orders-drop-left customers-search">
                    <div className="orders-dropdown">
                      <select
                        value={searchField}
                        onChange={(e) => handleFieldChange(e)}
                        className="form-control search-field"
                      >
                        <option value="" disabled>
                          {t("searchby_field_txt")}
                        </option>
                        <option value="accountCode">{t("account_code_txt")}</option>
                        <option value="accountName">{t("account_name_txt")}</option>
                        <option value="accountEmail">{t("email_address_txt")}</option>
                        <option value="accountPriceListId">{t("price_band_txt")}</option>
                        <option value="Sectors">{t("sector_txt")}</option>
                        <option value="mainDepot">{t("main_depot_txt")}</option>
                        <option value="subDepot">{t("local_depot_txt")}</option>
                      </select>
                    </div>
                    <div className="table-search-reset">
                      <div className="table-search search-input-wrapper">
                        {searchField === "mainDepot" &&
                          <select className="search-ord" onChange={(e) => handleChange(e.target.value)} value={searchTextVal}>
                            <option value="">{t("select_txt")}</option>
                            {mainDepotList.map(item => (
                              <option key={item.mainDepot} value={item.mainDepot}>{item.mainDepot}</option>
                            ))}
                          </select>
                        }
                        {searchField === "subDepot" &&
                          <select className="search-ord" onChange={(e) => handleChange(e.target.value)} value={searchTextVal}>
                            <option value="">{t("select_txt")}</option>
                            {subDepotList.map(item => (
                              <option key={item.subDepot} value={item.subDepot}>{item.subDepot}</option>
                            ))}
                          </select>
                        }
                        {searchField === "Sectors" &&
                          <select
                            value={searchTextVal}
                            onChange={(e) => handleChange(e.target.value)}
                            className="search-ord"
                          >
                            <option value="">{t("select_sector_txt")}</option>
                            {sectorOptions && sectorOptions.length > 0 ? (
                              sectorOptions.map((sector, index) => (
                                <option key={index} value={sector}>{sector}</option>
                              ))
                            ) : (
                              <option value="" disabled>{t("no_sectors_available_txt")}</option>
                            )}
                          </select>}
                        {searchField !== "Sectors" && searchField !== "mainDepot" && searchField !== "subDepot" && <input
                          type="text"
                          value={searchTextVal}
                          onChange={(e) => handleChange(e.target.value)}
                          className="form-control"
                          placeholder={`${t("searchby_txt")} ${searchFieldtxt}`}
                        />
                        }
                        {searchField === "accountPriceListId" &&
                          searchTextVal.trim() !== "" &&
                          suggestions.length > 0 && (
                            <ul className="suggestions-list">
                              {suggestions.map((item, index) => (
                                <li key={index} onClick={() => handleSuggestionClick(item)}>
                                  {item}
                                </li>
                              ))}
                            </ul>
                          )}
                      </div>
                      <button
                        className="submitbtn button search-cus-btn"
                        onClick={() => handleSearchClick()}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={handleReset}
                      >
                        {t("reset_txt")}
                      </button>
                    </div>
                  </div>
                  <div className="orders-dropdown vendor-select-drop">
                    <select
                      className="handle-srch"
                      value={sortBy}
                      onChange={(e) => handlesortbyChange(e.target.value)}
                    >
                      <option value="all">{t("show_all_records_txt")}</option>
                      <option value="Ordered">{t("ordered_txt")}</option>
                      <option value="Not Ordered">{t("not_ordered_txt")}</option>
                      <option value="lastLogin">{t("last_login_text")}</option>
                      <option value="createdAt">{t("created_on_txt")}</option>
                      <option value="updatedAt">{t("updated_on_txt")}</option>
                      <option value="Intro Email Sent">{t("intro_email_sent_txt")}</option>
                    </select>
                    {!["all"].includes(sortBy) && (<div className="dropdown-container"
                      onMouseEnter={() => {
                        if (period === "custom" && !showDatePicker) {
                          setShowDatePicker(true);
                        }
                      }}
                      onMouseLeave={() => {
                        if (period === "custom" && showDatePicker) {
                          setShowDatePicker(false);
                        }
                      }}>
                      <select
                        className="handle-srch"
                        value={period}
                        onChange={(e) => handlesortChange(e.target.value, e.target.options[e.target.selectedIndex].text)}
                      >
                        <option value="">
                          Select
                        </option>
                        <option value="30">{t("past_30_days_txt")}</option>
                        <option value="90">{t("past_90_days_txt")}</option>
                        <option value="180">{t("past_180_days_txt")}</option>
                        <option value="365">{t("past_1_year_txt")}</option>
                        <option value="custom">{t("custom_date_txt")}</option>
                      </select>
                      {showDatePicker && (
                        <div className="date-picker-container">
                          <label>{t("from_label_txt")}</label>
                          <DatePicker
                            selected={fromDate}
                            onChange={(date) => DateChange(date, "from")}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            disablePast={true}
                            maxDate={new Date()}
                            placeholderText={t("select_date_txt")}
                          />
                          <label>{t("to_label_txt")}</label>
                          <DatePicker
                            selected={toDate}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) => DateChange(date, "to")}
                            disablePast={true}
                            maxDate={new Date()}
                            placeholderText={t("select_date_txt")}
                          />
                        </div>
                      )}
                    </div>)}
                    <select
                      value={statusFilterVal}
                      className="handle-srch"
                      onChange={(e) => handleStatusChange(e.target.value)}
                    >
                      <option value="" disabled>
                        Status
                      </option>
                      <option value=" ">{t("all_txt")}</option>
                      <option value="active">{t("active_txt")}</option>
                      <option value="deactive">{t("inactive_txt")}</option>
                    </select>
                  </div>
                </div>
                <div className="table_overflow vendor-list-table">
                  {sortBy != 'all' && period != '' && loading === false && accounts.length > 0 && (
                    <div className="selected-dates">
                      <p className="admin-order account-total-records">
                        {t("total_record_txt")}{" "}
                        {accounts.length > 0
                          ? accounts.length
                          : ""}
                        {
                          fromDate && toDate ? (
                            <span>
                              {" "}
                              ({t("from_txt")} {formatDate(
                                fromDate
                              )}{" "}
                              {t("to_txt")} {formatDate(toDate)})
                            </span>
                          ) : periodtext && periodtext != t("custom_date_txt") ? (
                            ` (${periodtext})`
                          ) : (
                            ""
                          )
                        }
                      </p>
                    </div>
                  )}
                  <div className="full-text-toggle custom_check-box">
                    <div className="check-box">
                      <input
                        type="checkbox"
                        id="fullTextToggle"
                        checked={fullText}
                        onChange={() => setFullText(!fullText)}
                      />
                      <label htmlFor="fullTextToggle">
                        {t("show_full_text_txt")}
                      </label>
                    </div>
                  </div>
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_customers_found_txt")}
                      </div>
                    }
                    data={accounts}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
        {showDialog && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{t("alert_txt")}</h4>
                </div>
                <div className="custom-alert-body">
                  <p>
                    {confirmationAction.action === "activate"
                      ? isEmailToBeSent === "yes"
                        ? t("activateCustomerWithEmail", {
                            accountCode: confirmationAction.accountcode,
                          })
                        : t("activateCustomerWithoutEmail", {
                            accountCode: confirmationAction.accountcode,
                          })
                      : t("deactivateCustomer", {
                          accountCode: confirmationAction.accountcode,
                        })}
                  </p>
                  <div className="alert-buttons">
                    <button
                      onClick={confirmActionHandler}
                      className="popup-alert-btn button"
                    >
                      {t("ok_txt")}
                    </button>
                    <button
                      onClick={hideConfirmationDialog}
                      className="popup-alert-btn button"
                    >
                      {t("cancel_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showReasonPopup && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{confirmationAction.action} ({confirmationAction.accountcode})</h4>
                </div>
                <div className="custom-alert-body text-left">
                  {confirmationAction.action === "activate" && (
                    <div className="input-field">
                      <label htmlFor="emailOption">{t("activate_option_txt")}</label>
                      <select
                        id="emailOption"
                        name="emailOption"
                        value={isEmailToBeSent}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setIsEmailToBeSent(selectedValue);
                          setEmailError(false);
                          if (selectedValue === "yes") {
                            const emailCountURL = BaseUrl + "admin/emailcount";
                            const payload = { accountCode: confirmationAction.accountcode };
                            http.post(emailCountURL, payload)
                              .then((response) => {
                                const count = response.data.data || 0;
                                setEmailCount(count);
                              })
                              .catch((error) => {
                                console.error("Error fetching email count:", error);
                                setEmailCount(t("err_fetching_count_txt"));
                              });
                          } else {
                            setEmailCount(null);
                          }
                        }}
                      >
                        <option value="">{t("select_activation_option_txt")}</option>
                        <option value="yes">{t("activate_with_intro_email_txt")}</option>
                        <option value="no">{t("activate_without_intro_email_txt")}</option>
                      </select>
                      {isEmailToBeSent === "yes" && (
                        <><div className="input-info-msg">
                          <strong>{t("intro_email_previously_sent_txt")}</strong>
                          {emailCount !== null
                            ? emailCount
                            : <div class="loading-dots">
                              <div class="dot-small"></div>
                              <div class="dot-small"></div>
                              <div class="dot-small"></div>
                            </div>}
                        </div>
                          <div className="input-field">
                            <label>{t("treat_customer_as_new_for_emails_txt")}</label>
                            <select
                              value={emailMode}
                              onChange={(e) => setEmailMode(e.target.value)}
                            >
                              <option value="">{t("select_txt")}</option>
                              <option value="fresh">{t("yes_start_from_today_txt")}</option>
                              <option value="history">{t("no_continue_previous_history_txt")}</option>
                            </select>
                          </div>
                        </>
                      )}
                      {emailError && (
                        <div className="error-msg">{t("field_required_txt")}</div>
                      )}
                    </div>
                  )}
                  <div className="input-field">
                    <span className="labeltxt">{t("post_comment_label_txt")}</span>
                    <textarea
                      name="reason"
                      onChange={(e) =>
                        handleReasonChange(e.target.value)
                      }
                    ></textarea>
                    {reasonError && (
                      <div className="error-msg">{t("field_required_txt")}</div>
                    )}
                  </div>
                  <div className="alert-buttons">
                    <button
                      onClick={showConfirmationDialog}
                      className="popup-alert-btn button"
                    >
                      {t("submit_txt")}
                    </button>
                    <button
                      onClick={hideConfirmationDialog}
                      className="popup-alert-btn button"
                    >
                      {t("cancel_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showcustomPopup && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{t("alert_txt")}</h4>
                </div>
                <div className="custom-alert-body">
                  <p>{uploadMessage}</p>

                  <div className="alert-buttons">
                    <button
                      onClick={closeCustomPopup}
                      className="popup-alert-btn button"
                    >
                      {t("ok_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {popupView}
        {popuplogView}
        {popupPricebandView}
        {editvendor && (
          <EditvendorDetails
            VendorDetails={VendorDetails}
            popupclose={editclosepopup}
            editvendorDetails={ediVendorsdetails}
          />
        )}
        {showPopup && (
          <ChangePassword
            popupclose={closepopup}
            emailadd={Vendoremailadd}
            accCode={Vendoraccountcode}
          />
        )}
        {popupImportView && (
          <CustomerImport
            closePopup={importClosepopup}
            impValue={importValue}
          />
        )}
        {isUploading && (
          <div className="loading-overlay">
            <div className="loading-message">{t("importing_load_txt")}</div>
          </div>
        )}
      </div>
      {visibleAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_send_reset_password_link_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={triggerMail}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {visibledeleteAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("delete_session_text")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_session_txt", { accountCode: customeraccount })}</p>
                <div className="alert-buttons">
                  <a
                    onClick={triggerDelete}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={DeletePopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showExportAlert && (
        <div className='custom-alert-pop paylater-popup'>
          <div className='custom-alert-container'>
            <div className='custom-alert-wrap'>
              <div className='custom-alert-header'>
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className='custom-alert-body'>
                <p>{t("confirm_export_customers_txt")}</p>
                <div className='alert-buttons'>
                  <a onClick={handleExportToExcel} className="popup-alert-btn button">{t("ok_txt")}</a>
                  <a onClick={handleCloseExportAlert} className="popup-alert-btn button">{t("cancel_txt")}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showNoDataAlert && (
        <div className='custom-alert-pop paylater-popup'>
          <div className='custom-alert-container'>
            <div className='custom-alert-wrap'>
              <div className='custom-alert-header'>
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className='custom-alert-body'>
                <p>{t("no_customers_found_for_export_txt")}</p>
                <div className='alert-buttons'>
                  <a onClick={handleCloseNoDataAlert} className="popup-alert-btn button">{t("ok_txt")}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Vendors;
